<div class="wrapper">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-3">
                        <a (click)="add()" [class.disabled]="create" class="btn btn-sm btn-primary" style="color: white;">Add New Academic</a>
                    </div>
                    <div class="col-sm-3">

                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item active">Academic List</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Academic List</h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
                            <i class="fas fa-minus"></i></button>
                    </div>
                </div>
                <div class="card-body p-0">
                    <table class="table table-striped projects" *ngIf="loadTable" datatable>
                        <thead>
                            <tr>
                                <th>
                                    Sno
                                </th>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Academic Code
                                </th>
                                <th>
                                    From Year
                                </th>
                                <th>
                                    To Year
                                </th>
                                <th>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of academiclist;let i = index;">
                                <td>{{ i + 1 }}</td>
                                <td>{{ data.date | date: "dd-MM-yyyy" }}</td>
                                <td><a>{{ data.AcademicCode }}</a></td>
                                <td><a><a>{{ data.FromYear }}</a></a>
                                </td>
                                <td><a><a>{{ data.ToYear }}</a></a>
                                </td>
                                <td class="project-actions text-right">
                                    <a *ngIf="data.Status == 'Active'" [class.disabled]="edit" class="btn btn-info btn-sm" data-toggle="modal" data-target="#exampleModalCenter" style="color: white;" (click)="open(data.id,data.AcademicCode,data.FromYear,data.ToYear)">
                                        <i class="fas fa-pencil-alt">
                                        </i> Edit
                                    </a>&nbsp;
                                    <a *ngIf="data.Status == 'Active'" [class.disabled]="del" class="btn btn-danger btn-sm" style="color: white;" (click)="delete(data.id,'Inactive','You will not be able to recover this Academic Details!','Yes, delete it!')">
                                        <i class="fas fa-trash">
                                        </i> Delete
                                    </a>
                                    <a *ngIf="data.Status == 'Inactive'" [class.disabled]="del" class="btn btn-success btn-sm" style="color: white;" (click)="delete(data.id,'Active','You will Activate this Academic Details!','Yes, Activate it!')">
                                        <i class="far fa-check-circle"></i> Activate
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
    <app-footer></app-footer>
</div>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="exampleModalLongTitle">Update Academic</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="myform">
                    <div class="form-group">
                        <label for="inputName">Academic Code</label>
                        <input type="text" id="inputName" class="form-control" formControlName="code" [ngClass]="{ 'is-invalid': submitted && f.code.errors }">
                        <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
                            <div *ngIf="f.code.errors.required">Academic Code is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputDescription">From Year</label>
                        <select class="form-control custom-select" formControlName="from_year" [ngClass]="{ 'is-invalid': submitted && f.from_year.errors }">
                            <option selected disabled>Select From Year</option>
                            <option value="2026">2026</option>
                            <option value="2025">2025</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                            <option value="2019">2019</option>
                            <option value="2018">2018</option>
                            <option value="2017">2017</option>
                            <option value="2016">2016</option>
                            <option value="2015">2015</option>
                            <option value="2014">2014</option>
                            <option value="2013">2013</option>
                            <option value="2012">2012</option>
                            <option value="2010">2010</option>
                            <option value="2009">2009</option>
                            <option value="2008">2008</option>
                            <option value="2007">2007</option>
                            <option value="2006">2006</option>
                            <option value="2005">2005</option>
                            <option value="2004">2004</option>
                            <option value="2003">2003</option>
                        </select>
                        <div *ngIf="submitted && f.from_year.errors" class="invalid-feedback">
                            <div *ngIf="f.from_year.errors.required">From Year is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputDescription">To Year</label>
                        <select class="form-control custom-select" formControlName="to_year" [ngClass]="{ 'is-invalid': submitted && f.to_year.errors }">
                            <option selected disabled>Select To Year</option>
                            <option value="2026">2026</option>
                            <option value="2025">2025</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                            <option value="2019">2019</option>
                            <option value="2018">2018</option>
                            <option value="2017">2017</option>
                            <option value="2016">2016</option>
                            <option value="2015">2015</option>
                            <option value="2014">2014</option>
                            <option value="2013">2013</option>
                            <option value="2012">2012</option>
                            <option value="2010">2010</option>
                            <option value="2009">2009</option>
                            <option value="2008">2008</option>
                            <option value="2007">2007</option>
                            <option value="2006">2006</option>
                            <option value="2005">2005</option>
                            <option value="2004">2004</option>
                            <option value="2003">2003</option>
                        </select>
                        <div *ngIf="submitted && f.to_year.errors" class="invalid-feedback">
                            <div *ngIf="f.to_year.errors.required">To Year is required</div>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <div class="col-12">
                        <input type="submit" value="Update" class="btn btn-success" data-dismiss="modal" (click)="submit()">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>